import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';

@Component({
  selector: 'app-ask-to-show-info-dialog',
  templateUrl: './ask-to-show-info-dialog.component.html',
  styleUrls: ['./ask-to-show-info-dialog.component.scss']
})
export class AskToShowInfoDialogComponent implements OnInit {

  private user;
  experiences: any[] = [];
  educations: any[] = [];
  submiting: boolean = false;
  
  constructor(
    private http: HttpService,    
    private dialogRef: MatDialogRef<AskToShowInfoDialogComponent>,
    private errorReport: ErrorReportService,
    private snackbar: MatSnackBar
  ) { }

  ngOnInit(): void {

    const subject = new Subject<any>();
    subject.subscribe(
      (result: any) => {

        const { trigger, scope } = result;
        
        if(scope == 'profile:show_info')
          this.submiting = trigger === 'pre';

      }
    );

    this.http.setLoadingIndicator(subject);
    this.user = JSON.parse(localStorage.getItem('token'));

    this.getProfessional();

  }

  getProfessional() {

    const params = {
      id: this.user.id,
      all: true
    }
    this.http.get('experience', params)
      .subscribe(
        (result: any) => {
          this.experiences = result.data.slice(0, 3);
          this.getEducation();
        },
        (err: any) => {          
          console.error(err);
        }
      )

  }

  getEducation() {

    const params = {
      id: this.user.id,
      all: true
    }
    this.http.get('education', params)
      .subscribe(
        (result: any) => {
          
          this.educations = result.data.slice(0, 3);
          
          if(this.educations.length === 0 && this.experiences.length === 0){}
            // this.dialogRef.close();

        },
        (err: any) => {
          console.error(err);
        }
      )

  }

  sendResponse(showInfo: boolean = false) {

    const body = {
      id: this.user.id,
      showInfo
    }
    
    this.http.save('profile:show_info', body)
      .subscribe(
        (result: any) => {          
          this.dialogRef.close();
          this.snackbar.open('Atualização feita com sucesso!', 'OK', { duration: 3000 });
          this.user.mostrar_experiencias = showInfo;
          localStorage.setItem('token', JSON.stringify(this.user));
        },
        (err: any) => {
          this.errorReport.showMessage(err);
        }
      )

  }

}
